<template>
  <div ref="wrap" class="ats-viewport-scale">
    <div ref="inner" class="ats-viewport-scale__inner">
      <slot />
    </div>
  </div>
</template>

<script>
import {
  DESIGN_WIDTH,
  clearRootPageZoom,
  getAtsScale,
  getViewportWidth
} from '@/util/pageScale'

/**
 * 按视口宽度等比缩放 ATS 专题页，铺满宽度且保持比例
 */
export default {
  name: 'AtsViewportScale',
  data () {
    return {
      /** @type {ResizeObserver|null} */
      resizeObserver: null
    }
  },
  watch: {
    '$route.path' () {
      this.$nextTick(this.applyScale)
    }
  },
  mounted () {
    clearRootPageZoom()
    this.applyScale()
    window.addEventListener('resize', this.applyScale, { passive: true })
    if (typeof ResizeObserver !== 'undefined' && this.$refs.inner) {
      this.resizeObserver = new ResizeObserver(() => {
        this.applyScale()
      })
      this.resizeObserver.observe(this.$refs.inner)
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.applyScale)
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  },
  methods: {
    /**
     * 检测浏览器是否支持 layout zoom
     * @returns {boolean}
     */
    supportsZoom () {
      return typeof document.body.style.zoom !== 'undefined'
    },
    /**
     * 根据视口宽度计算缩放比（铺满宽度，可大于 1）
     * @returns {number}
     */
    getScale () {
      return getAtsScale(getViewportWidth())
    },
    /**
     * 补偿外层高度，避免 transform 缩放后留白
     * @param {HTMLElement} wrap
     * @param {HTMLElement} inner
     * @param {number} scale
     * @returns {void}
     */
    syncWrapHeight (wrap, inner, scale) {
      if (Math.abs(scale - 1) < 0.001) {
        wrap.style.height = ''
        return
      }
      wrap.style.height = `${inner.scrollHeight * scale}px`
    },
    /**
     * 应用等比缩放，从左对齐铺满视口宽度
     * @returns {void}
     */
    applyScale () {
      clearRootPageZoom()

      const wrap = this.$refs.wrap
      const inner = this.$refs.inner
      if (!wrap || !inner) {
        return
      }

      const scale = this.getScale()
      const isUnitScale = Math.abs(scale - 1) < 0.001

      inner.style.width = `${DESIGN_WIDTH}px`
      inner.style.marginLeft = '0'
      inner.style.marginRight = '0'

      wrap.style.width = '100%'
      wrap.style.maxWidth = '100%'
      wrap.style.overflowX = 'hidden'

      if (this.supportsZoom()) {
        inner.style.transform = ''
        inner.style.transformOrigin = ''
        inner.style.zoom = isUnitScale ? '' : String(scale)
        this.syncWrapHeight(wrap, inner, scale)
        return
      }

      /** Firefox 等：transform 从左上角缩放，视觉宽度 = 1920 × scale = 视口宽 */
      inner.style.zoom = ''
      inner.style.transform = isUnitScale ? '' : `scale(${scale})`
      inner.style.transformOrigin = 'top left'
      this.syncWrapHeight(wrap, inner, scale)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './ats-viewport-units.scss';

.ats-viewport-scale {
  width: 100%;
  overflow-x: hidden;
}

.ats-viewport-scale__inner {
  width: 1920px;
  margin: 0;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/ats/AtsViewportScale.vue